import { formatCurrency } from '@utils'
import cn from 'clsx'

import Pagination from '@components/shared/Pagination'

import './CheckRevenueTable.css'
import { formatDate } from '@/utils/date'

const CheckRevenueTable = ({
    className,
    rows,
    checkRevenue,
    pageCount,
    itemsPerPage,
    setPageIndex,
}) => {
    
    return (
        
        <div className={cn('CheckRevenueTable', className)}>
            
            <div className="flex items-center content-center justify-around">
                <div>
                    <h5 className="text-lg">Owner Gross Revenue</h5>
                    <div className="text-3xl">
                        {formatCurrency(checkRevenue?.gross || 0)}
                    </div>
                </div>
                <div>
                    <h5 className="text-lg">Owner Adjustments</h5>
                    <div className="text-3xl">
                        {formatCurrency(checkRevenue?.adjustments || 0)}
                    </div>
                </div>
                <div>
                    <h5 className="text-lg">Owner Net Revenue</h5>
                    <div className="text-3xl">
                        {formatCurrency(checkRevenue?.net || 0)}
                    </div>
                </div>
            </div>
            
            <table className="mt-4 table-auto table-sticky-headers">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Owner Gross Revenue</th>
                        <th>Owner Adjustments Value</th>
                        <th>Owner Net Revenue</th>
                    </tr>
                </thead>
                <tbody>
                    {rows?.map((it, i) => {
                        
                        const salesDate = it.salesDate?.length
                            ? formatDate(it.salesDate, 'MMM, YYYY')
                            : <span className="text-muted">N/A</span>
                        
                        return (
                            <tr key={i}>
                                <td>{salesDate}</td>
                                <td>{formatCurrency(it.gross)}</td>
                                <td>{formatCurrency(it.adjustments)}</td>
                                <td>{formatCurrency(it.net)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            
            <div className="flex justify-center px-3 pt-3 pb-4">
                <Pagination
                    count={pageCount}
                    itemsPerPage={itemsPerPage}
                    setPageIndex={setPageIndex} />
            </div>
        
        </div>
        
    )
    
}

export default CheckRevenueTable
